<template>
<div id="content" class="content" style="margin-left:0px;">
	<h1 class="page-header" style="text-align:left">中创 <small>header small text goes here...</small></h1>
	<!-- end col-6 -->
	<div id="page-container" class="in page-sidebar-fixed page-header-fixed" style="padding-top:0px;">
		
	   		<div class="panel panel-inverse" data-sortable-id="form-stuff-10">
						<!-- begin panel-heading -->
						<div class="panel-heading">
							<div class="panel-heading-btn">
								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-default" data-click="panel-expand"><i class="fa fa-expand"></i></a>
								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-success" data-click="panel-reload"><i class="fa fa-redo"></i></a>
								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-warning" data-click="panel-collapse"><i class="fa fa-minus"></i></a>
								<a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-danger" data-click="panel-remove"><i class="fa fa-times"></i></a>
							</div>
							<h4 class="panel-title">银行卡设置</h4>
						</div>
						<!-- end panel-heading -->
						<!-- begin panel-body -->
						<div class="panel-body">
							<form action="/" method="POST">
								<fieldset>
									<div class="form-group row m-b-15">
										<label class="col-md-3 col-form-label">原先银行卡号</label>
										<div class="col-md-7">
											<input type="text" class="form-control-plaintext" value="22222222222" />
										</div>
									</div>
									<div class="form-group row m-b-15">
										<label class="col-md-3 col-form-label">修改银行卡号</label>
										<div class="col-md-7">
											<input type="text" class="form-control" placeholder="修改银行卡号" />
										</div>
									</div>
									<div class="form-group row">
										<div class="col-md-7 offset-md-3">
											   <div class="btn btn-primary m-r-5">确认修改</div>
											   <div class="btn btn-default">重置</div>
										</div>
									</div>
								</fieldset>
							</form>
						</div>
						<!-- end panel-body -->
					</div>
	
	</div>
	
</div>
</template>

<script>
export default {
  name: 'BankCardSettings',
  data () {
    return {
    
    }
  },
   mounted: function() {

     
 },
 methods:{
	
 }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EssentialInformation/BankCardSettings.vue